<template>
  <gh-invoke module="mes.business.mdl.meter.service" cls="MeterTypeService" method="get_all" :args="{}" @start="">
    <template v-slot="{args,data,loading}">
      <v-item-group>
        <v-item v-for="(item, index) in data" :key="item.Id">
          <v-chip slot-scope="{active,toggle}" :selected="active" @click="select(item,toggle)">
            <v-avatar right color="info">
              {{getValue(item.Id)}}
            </v-avatar>
            <span class="caption">{{item.Name}}</span>
            <v-icon color="success">{{item.icon}}</v-icon>
          </v-chip>

        </v-item>
        <v-item key="-1">
          <v-chip slot-scope="{active,toggle}" :selected="active" @click="select(null,toggle)">
            <v-avatar right color="info">
              {{getValue("-1")}}
            </v-avatar>
            <span class="caption">全部</span>
            <v-icon color="success">mdi-all-inclusive</v-icon>
          </v-chip>
        </v-item>
      </v-item-group>
    </template>
  </gh-invoke>
</template>

<style scoped>

</style>

<script>
  import MeterTypeNavigation from "./meterTypeNavigation.ts";
  export default MeterTypeNavigation;
</script>